function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
  id: "Icon_Design_-_Merged_Final",
  "data-name": "Icon Design - Merged Final"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.87 11.15a6.25 6.25 0 10-7.74 0 9.68 9.68 0 00-5.83 8.9v2.88A1.07 1.07 0 003.38 24h17.25a1.07 1.07 0 001.07-1.07v-2.88a9.68 9.68 0 00-5.83-8.9zM12 12.5a7.56 7.56 0 017.55 7.55v1.8H4.45v-1.8A7.56 7.56 0 0112 12.5zm0-10.35a4.1 4.1 0 11-4.1 4.1 4.11 4.11 0 014.1-4.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  opacity: ".5",
  d: "M0 0h24v24H0z"
})));